import { render, staticRenderFns } from "./EditarArticulo.vue?vue&type=template&id=b9f45e06&"
import script from "./EditarArticulo.vue?vue&type=script&lang=js&"
export * from "./EditarArticulo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports